import { render, staticRenderFns } from "./StartAnimation.vue?vue&type=template&id=a1023194&scoped=true"
import script from "./StartAnimation.vue?vue&type=script&lang=js"
export * from "./StartAnimation.vue?vue&type=script&lang=js"
import style0 from "./StartAnimation.vue?vue&type=style&index=0&id=a1023194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1023194",
  null
  
)

export default component.exports